import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Colors } from '../../../themes';
import { Button } from '../../crop-circle/Button';
import { colors, spacing, tokens } from '../../crop-circle/tokens';
import { OpenEndedResponse } from './types';

export type StatusExecutionComponentProps = {
  statuses: string[];
  value: string;
  onChange: (status: string) => void;
  disabled?: boolean;
  useCropCircle?: boolean;
};

// TODO: Crop Circle Redesign | Remove after feature is fully rolled out
const StatusExecutionComponentOld = (props: any) => {
  const lastStatusIndex = props.statuses.length - 1;

  const filteredStatuses = props.statuses.filter(
    (status: string | number) => status !== OpenEndedResponse
  );

  return (
    <View style={styles.buttonsContainer}>
      {filteredStatuses.map((status: string | number, i: number) => {
        const buttonBackgroundStyle = [styles.button];
        const buttonLabelStyle = [styles.buttonLabel];

        if (status === props.value) {
          buttonBackgroundStyle.push(styles.currentStateButton);
          buttonLabelStyle.push(styles.currentButtonLabel);
        }

        return (
          <TouchableOpacity
            key={status}
            activeOpacity={0.7}
            style={[
              buttonBackgroundStyle,
              i !== lastStatusIndex
                ? { marginBottom: 20 }
                : { marginBottom: 0 },
            ]}
            onPress={() => props.onChange(status)}
            disabled={props.disabled}
          >
            <Text style={buttonLabelStyle}>{status}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

// TODO: Crop Circle Redesign | Remove to StatusExecutionComponentBase after feature is fully rolled out
const StatusExecutionComponentBase = (props: StatusExecutionComponentProps) => {
  const filteredStatuses = props.statuses.filter(
    (status: string | number) => status !== OpenEndedResponse
  );

  return (
    <View style={stylesCropCircle.buttonsContainer}>
      {filteredStatuses.map((status: string | number) => {
        const isSelected = status === props.value;

        return (
          <Button
            key={status}
            onPress={() => props.onChange(String(status))}
            disabled={props.disabled}
            state={isSelected ? 'active' : 'default'}
            variant="rectangular"
            size="large"
          >
            <Text
              style={[
                stylesCropCircle.buttonLabel,
                isSelected && stylesCropCircle.currentButtonLabel,
              ]}
            >
              {status}
            </Text>
          </Button>
        );
      })}
    </View>
  );
};

export const StatusExecutionComponent = (
  props: StatusExecutionComponentProps
) => {
  if (props.useCropCircle) {
    return <StatusExecutionComponentBase {...props} />;
  }

  return <StatusExecutionComponentOld {...props} />;
};

const styles = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  button: {
    height: 52,
    borderWidth: 2,
    borderRadius: 51,
    borderColor: Colors.blue,
    alignItems: 'center',
    justifyContent: 'center',
  },
  currentStateButton: {
    backgroundColor: Colors.blue,
  },
  buttonLabel: {
    color: Colors.black,
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 19,
  },
  currentButtonLabel: {
    color: Colors.white,
  },
});

const stylesCropCircle = StyleSheet.create({
  buttonsContainer: {
    flexDirection: 'column',
    gap: spacing.sm,
  },
  buttonLabel: {
    ...tokens.typography.body.medium,
    color: colors.slate[700],
  },
  currentButtonLabel: {
    color: colors.brand.white,
  },
});
